import React from 'react';
import { CustomButton } from 'components/Button';
import { EnterpriseContactForm, useEnterpriseContact } from "components/EnterpriseContact";
import EnterpriseDeploymentIcon from "assets/images/enterprise-deployment.svg";
import EnterpriseBrandingIcon from "assets/images/enterprise-branding.svg";
import EnterpriseApiIcon from "assets/images/enterprise-api.svg";
import EnterpriseManagementIcon from "assets/images/enterprise-management.svg";
import EnterpriseSecurityIcon from "assets/images/enterprise-security.svg";
import EnterpriseSupportIcon from "assets/images/enterprise-support.svg";
import './enterpriseSection.css';

const EnterpriseSection: React.FC = () => {
  const { isOpen: isEnterpriseOpen, isPending: isEnterprisePending, handleOpen: handleEnterpriseOpen, handleClose: handleEnterpriseClose, handleSubmit: handleEnterpriseSubmit } = useEnterpriseContact();

  const handleEnterpriseSolutionsClick = () => {
    // Navigate to enterprise solutions page
    window.location.href = '/enterprise-solutions';
  };

  return (
    <section className="features-section">
      <div className="enterprise-scroll-element"></div>
      <h2 className="features-title">
        Enterprise Lottery Management for Multi-Store Retail Chains
      </h2>
      <p className="features-subtitle">
        Scale from 5 to 500+ locations with our comprehensive lottery management platform designed for retail chains, franchise organizations, and enterprise operations.
      </p>
      <div className="custom-container d-flex items-center width-100">
        <div className="features-grid">
          <div className="feature-card">
            <img
              className="feature-icon"
              src={EnterpriseDeploymentIcon}
              alt="Flexible deployment options for lottery management software"
              loading="lazy"
            />
            <div>
              <h3>Flexible Deployment Options</h3>
              <p>
                Deploy as a standalone SaaS platform or integrate deeply with your existing ERP systems. 
                Our lottery management software supports both cloud and on-premise deployments, 
                giving you complete control over your infrastructure and data.
              </p>
            </div>
          </div>
          
          <div className="feature-card">
            <img
              className="feature-icon"
              src={EnterpriseBrandingIcon}
              alt="White-label lottery software for franchise organizations"
              loading="lazy"
            />
            <div>
              <h3>White-Label & Co-Branding Solutions</h3>
              <p>
                Maintain your brand identity with complete white-label lottery software. 
                Custom domains, branded mobile applications, and seamless integration into 
                your existing corporate portals for franchise organizations and distributors.
              </p>
            </div>
          </div>
          
          <div className="feature-card">
            <img
              className="feature-icon"
              src={EnterpriseApiIcon}
              alt="API integration for enterprise lottery management"
              loading="lazy"
            />
            <div>
              <h3>API-First Architecture for Custom Integration</h3>
              <p>
                RESTful APIs and webhooks enable seamless integration with POS systems, 
                ERP platforms, and custom applications. Built for developers and IT teams 
                who need enterprise-grade lottery management integration.
              </p>
            </div>
          </div>
          
          <div className="feature-card">
            <img
              className="feature-icon"
              src={EnterpriseManagementIcon}
              alt="Multi-store lottery management dashboard"
              loading="lazy"
            />
            <div>
              <h3>Centralized Multi-Store Management</h3>
              <p>
                Single dashboard for all locations with real-time visibility and control. 
                Manage lottery operations across your entire retail chain with role-based 
                access control and bulk operations for enterprise efficiency.
              </p>
            </div>
          </div>
          
          <div className="feature-card">
            <img
              className="feature-icon"
              src={EnterpriseSecurityIcon}
              alt="Enterprise security for lottery management"
              loading="lazy"
            />
            <div>
              <h3>Enterprise Security & Data Protection</h3>
              <p>
                Advanced security features with enterprise-grade data protection and secure 
                authentication. Built for organizations that require robust security standards 
                for lottery management operations.
              </p>
            </div>
          </div>
          
          <div className="feature-card">
            <img
              className="feature-icon"
              src={EnterpriseSupportIcon}
              alt="Dedicated enterprise support for lottery management"
              loading="lazy"
            />
            <div>
              <h3>Dedicated Enterprise Support</h3>
              <p>
                Named account manager and priority support for enterprise customers. 
                Custom training programs, quarterly business reviews, and dedicated 
                technical resources for large-scale lottery management implementations.
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="enterprise-cta-section">
        <div className="custom-container d-flex items-center justify-center width-100">
          <div className="enterprise-cta-content">
            <h3>Ready to Scale Your Lottery Operations?</h3>
            <p>Join enterprise retailers who trust LottoReco for their multi-store lottery management needs.</p>
            <div className="enterprise-cta-buttons">
              <CustomButton
                className="button-base button-compact enterprise-cta-primary"
                onClick={handleEnterpriseSolutionsClick}
              >
                View Enterprise Solutions
              </CustomButton>
              <CustomButton
                className="button-base button-compact enterprise-cta-secondary"
                onClick={handleEnterpriseOpen}
              >
                Schedule Enterprise Consultation
              </CustomButton>
            </div>
          </div>
        </div>
      </div>
      
      {/* Enterprise Contact Form */}
      <EnterpriseContactForm
        open={isEnterpriseOpen}
        onClose={handleEnterpriseClose}
        onSubmit={handleEnterpriseSubmit}
        isPending={isEnterprisePending}
      />
    </section>
  );
};

export default EnterpriseSection;
